export default __webpack_public_path__ + "static/aws-69d9b9b072e372d0115f950c55575c56.png";